
import { useCallback, useEffect, useMemo, useState } from "react"
import { useLocation, useParams  } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { getWarrantyForm, sendSystemMessage, sendWarrantyForm, verifyOtp } from "../../api/warranty"
import { Form, message } from "antd";
import { CloseCircleOutlined } from '@ant-design/icons';

export const useWarrantyForm = props => {

    const { formatMessage } = useIntl();

    const emailFormat = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const {pathname, search} = useLocation ();
    const {merchant_code} = useParams()
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [urlParams, setUrlParams] = useState(null);
    const [merchantCode, setMerchantCode] = useState('');

    const [allSelectOptions, setAllSelectOptions] = useState({});
    const [allSelectValues, setAllSelectValues] = useState({});
    const [allOriginOptions, setAllOriginOptions] = useState([]);
    const [formToken, setFormToken] = useState({});
    const [warrantyGroup, setWarrantyGroup] = useState([]);

    const [fileList, setFileList] = useState([]);
    const [base64List, setBase64List] = useState([]);

    const [dateString, setDateString] = useState('');

    const [btnDisable, setBtnDisable] = useState(false);

    const [canSendOtp, setCanSendOtp] = useState(false);
    const [waitOtpSeconds, setWaitOtpSeconds] = useState(0);
    const [inputEmail, setInputEmail] = useState('');
    const [otpLoading, setOtpLoading] = useState(false);
    const [otpValue, setOtpValue] = useState('');
    const [validateOtpLoading, setValidateOtpLoading] = useState(false);
    const [validateOtpResult, setValidateOtpResult] = useState(null);
    const [validateOtpValue, setValidateOtpValue] = useState(null);

    const [searchValue, setSearchValue] = useState({});

    const [alertMessage, setAlertMessage] = useState([]);
    const [uploadAlertMessage, setUploadAlertMessage] = useState([]);

    /**  upload相关 start** */
    const handleRemoveFile = useCallback((file)=>{
        const d_index = base64List.findIndex(data=>data.id === file.uid);
        if(d_index >= 0) {
            const newBase64List = base64List.slice();
            newBase64List.splice(d_index, 1);
            setBase64List(newBase64List);
        }
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
        if(!newFileList?.length) {
            setUploadAlertMessage([])
        }
    }, [fileList, base64List])

    const handleBeforeUpload = useCallback((file)=>{
        const isJpgOrPng = file.type === "image/png" || file.type === "image/gif" || file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "application/pdf";
        if (!isJpgOrPng) {
            const message_key = `custom_message_${Date.now()}`;
            const messageContent = {
                key: message_key,
                type: 'error',
                content: <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '8px',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {formatMessage({
                        id: "form.uploadTypeTips", 
                        defaultMessage: "Allowed file types: png gif jpg jpeg pdf."
                    })}
                    {/* <div style={{
                        cursor: 'pointer'
                    }} onClick={()=>{
                        messageApi.destroy(message_key)
                    }}>
                        <CloseCircleOutlined style={{color: "#D54941"}} />
                    </div> */}
                </div>,
                duration: 0, // 设置为0表示不自动关闭
            }
            // messageApi.open(messageContent);
            setUploadAlertMessage([messageContent]);
            return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            const message_key = `custom_message_${Date.now()}`;
            const messageContent = {
                key: message_key,
                type: 'error',
                content: <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '8px',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {formatMessage({
                        id: "form.uploadSizeTips", 
                        defaultMessage: "Files must be less than 5MB."
                    })}
                    {/* <div style={{
                        cursor: 'pointer'
                    }} onClick={()=>{
                        messageApi.destroy(message_key)
                    }}>
                        <CloseCircleOutlined style={{color: "#D54941"}} />
                    </div> */}
                </div>,
                duration: 0, // 设置为0表示不自动关闭
            }
            // messageApi.open(messageContent);
            setUploadAlertMessage([messageContent]);
            return false;
        }
        if(isJpgOrPng && isLt2M) {
            setUploadAlertMessage([]);
        }
        return isJpgOrPng && isLt2M;
    }, [formatMessage, messageApi])

    const handleFormatFile = useCallback((option)=>{
        const formData = new FormData();
        formData.append("files[]", option.file);
        const reader = new FileReader();
        reader.readAsDataURL(option.file);
        reader.onloadend = function(e) {
            setBase64List([{
                id: option.file.uid,
                data: e.target.result // 保存图片的base64
            }])
            if (e && e.target && e.target.result) {
                option.onSuccess();
            }
        };
    }, [])

    const handleOnChangeFile = useCallback((info)=>{
        setFileList(info.fileList);
    }, [])
    /**  upload相关 end** */

    //改变form数据的格式
    const handleFormatWarrantyGroup = useCallback((data)=>{
        let group = [];
        if(data?.length > 2) {
            group.push([])
            group.push([])
            data.forEach((item, index)=>{
                if(index < 2) {
                    group[0].push(item);
                }
                else {
                    group[1].push(item);
                }
            })
        }
        else if(data?.length) {
            data.forEach(item=>{
                group.push([item]);
            })
        }
        let allOrigins = [];
        let allSelects = {};
        let allValues = {};
        data.forEach(item=>{
            item?.groupField.forEach(f_item=>{
                if(f_item.fieldType === 'single_select' && f_item.display) {
                    allOrigins.push({
                        name: f_item.fieldCode,
                        label: f_item.fieldName,
                        options: f_item.options
                    });
                    if(f_item.fieldCode === 'category') {
                        allSelects[f_item.fieldCode] = [
                            {
                                label: formatMessage({
                                    id: "form.categoryPlaceholder", 
                                    defaultMessage: "- Select product category -"
                                }),
                                value: undefined
                            },
                            ...f_item.options.filter(option=>!option.isRely)
                        ];
                    }
                    else if(f_item.fieldCode !== 'series' && f_item.fieldCode !== 'sku') {
                        allSelects[f_item.fieldCode] = [
                            ...f_item.options.filter(option=>!option.isRely)
                        ];
                    }
                    allValues[f_item.fieldCode] = undefined;
                }
            })
        })
        setAllOriginOptions(allOrigins);
        setAllSelectOptions(allSelects);
        setAllSelectValues(allValues);
        setWarrantyGroup(group);
    }, [formatMessage])

    //获取form数据
    const handleGetFormData = useCallback((code, language, isFirst, c_code)=>{
        //setLoading(true);
        getWarrantyForm({
            code: code,
            language: language
        }, c_code).then(res=>{
            if(res?.warrantyGroup?.length && res?.secureValue && res?.secureLabel) {
                setErrorMessage(null);
                if(isFirst) {
                    handleFormatWarrantyGroup(res?.warrantyGroup);
                }
                setFormToken({
                    key: res?.secureLabel,
                    value: res?.secureValue
                })
            }
            else {
                setErrorMessage("empty form")
            }
            setLoading(false);
            setBtnDisable(false);
        }).catch(error=>{
            setErrorMessage(error.response?.data?.message || error.message);
            setLoading(false);
            setBtnDisable(false);
        })
    }, [handleFormatWarrantyGroup]);

    //返回rules
    const handleGetRules = useCallback((isRequired, validate, fieldName, otherValidate)=>{
        let rules = [];
        if(isRequired) {
            rules.push({
                required: true, message: formatMessage({
                    id: "form.isRequired", 
                    defaultMessage: "{name} is required!"
                }, {
                    name: fieldName
                })
            })
        }
        if(validate === 'email') {
            rules.push({
                pattern: emailFormat,
                message: formatMessage({
                    id: "form.isEmail", 
                    defaultMessage: "Please enter a valid email account"
                })
            })
        }
        if(otherValidate === 'serial_validate') {
            //限制必须输入13个字符
            rules.push({
                pattern: /^.{13}$/,
                message: formatMessage({
                    id: "form.isSerialNumber", 
                    defaultMessage: "Please put 13 characters into {name}."
                }, {
                    name: fieldName
                })
            })
        }
        return rules;
    }, [formatMessage, emailFormat])

    //select改变内容时，其他联动select也跟着变
    const handleChangeSelect = useCallback((fieldCode, val)=>{
        setSearchValue({});
        if(fieldCode === 'category') {
            if(!val) {
                setAllSelectValues(selectValues=>{
                    return  {
                        ...selectValues,
                        [fieldCode]: val,
                        series: undefined,
                        sku: undefined,
                    }
                })
                setAllSelectOptions(selectOptions=>{
                    return {
                        ...selectOptions,
                        series: [],
                        sku: []
                    }
                })
            }
            else {
                const findField = allOriginOptions.find(item=>item.options.find(o_item=>o_item.isRely && o_item.relyField === 'category' && o_item.relyValue === val));
                setAllSelectValues(selectValues=>{
                    return  {
                        ...selectValues,
                        [fieldCode]: val,
                        series: undefined,
                        sku: undefined,
                    }
                })
                form.setFieldValue(fieldCode, val);
                form.setFieldValue('series', undefined);
                form.setFieldValue('sku', undefined);
                const seriesOptions = findField?.options?.filter(option=>option.isRely && option.relyField === 'category' && option.relyValue === val);

                setAllSelectOptions(selectOptions=>{
                    return {
                        ...selectOptions,
                        series: seriesOptions?.length ? [
                            {
                                label: formatMessage({
                                    id: "form.seriesPlaceholder", 
                                    defaultMessage: "- Select product series -"
                                }),
                                value: undefined
                            },
                            ...seriesOptions
                        ] : [],
                        sku: []
                    }
                })
            }
        }
        else if(fieldCode === 'series') {
            if(!val) {
                setAllSelectValues(selectValues=>{
                    return  {
                        ...selectValues,
                        [fieldCode]: val,
                        sku: undefined,
                    }
                })
                setAllSelectOptions(selectOptions=>{
                    return {
                        ...selectOptions,
                        sku: [],
                    }
                })
            }
            else {
                const findField = allOriginOptions.find(item=>item.options.find(o_item=>o_item.isRely && o_item.relyField === 'series' && o_item.relyValue === val));
                setAllSelectValues(selectValues=>{
                    return  {
                        ...selectValues,
                        [fieldCode]: val,
                        sku: undefined,
                    }
                })
                form.setFieldValue(fieldCode, val);
                form.setFieldValue('sku', undefined);
                const skuOptions = findField?.options?.filter(option=>option.isRely && option.relyField === 'series' && option.relyValue === val);
                setAllSelectOptions(selectOptions=>{
                    return {
                        ...selectOptions,
                        sku: skuOptions?.length ? [
                            {
                                label: formatMessage({
                                    id: "form.skuPlaceholder", 
                                    defaultMessage: "- Model No.(SKU) -"
                                }),
                                value: undefined
                            },
                            ...skuOptions
                        ] : [],
                    }
                })
            }
        }
        else {
            form.setFieldValue(fieldCode, val);
            setAllSelectValues(selectValues=>{
                return {
                    ...selectValues,
                    [fieldCode]: val
                }
            })
        }
    }, [allOriginOptions, formatMessage, form]);

    //获取date的数据
    const handleChangeDatePicker = useCallback((date, dateString)=>{
        setDateString(dateString)
    }, []);

    //输入邮箱
    const handleChangeEmail = useCallback((val)=>{
        if(!waitOtpSeconds) {
            if(emailFormat.test(val)) {
                setCanSendOtp(true);
            }
            else {
                setCanSendOtp(false);
            }
        }
        setInputEmail(val);
        setValidateOtpResult(null);
        setValidateOtpValue(null);
        setOtpValue('');
        form.setFieldValue('otp', '');
        setValidateOtpLoading(false);
    }, [emailFormat, form, waitOtpSeconds])

    //发送验证码
    const handleStartSendOtp = useCallback(()=>{
        setCanSendOtp(false);
        setOtpLoading(true);
        setValidateOtpResult(null);
        setValidateOtpValue(null);
        sendSystemMessage({
            type: "OTP",
            id: inputEmail,
            content: {},
            merchant: merchant_code === 'uat_test' ? 'demo' : merchant_code,
            language: urlParams?.language || 'global'
        }, merchantCode).then(res=>{
            setOtpLoading(false);
            if(res?.status == '200') {
                messageApi.open({
                    type: 'info',
                    content: formatMessage({
                        id: "form.OTPSendSuccessLabel", 
                        defaultMessage: "Send the verification code to your email successfully!"
                    }),
                    duration: 5,
                });
                setWaitOtpSeconds(30);
                let countdown = 30;
                const tim = setInterval(function () {
                    countdown--;
                    setWaitOtpSeconds(countdown);
                    if (countdown == 0 || countdown < 0) {
                        clearInterval(tim);
                        setWaitOtpSeconds(0);
                        if(inputEmail) {
                            if(emailFormat.test(inputEmail) && !validateOtpResult && !validateOtpLoading) {
                                setCanSendOtp(true);
                            }
                            else {
                                setCanSendOtp(false);
                            }
                        }
                        else {
                            setCanSendOtp(false);
                        }
                    }
                }, 1000)
            }
            else {
                const message_key = `custom_message_${Date.now()}`;
                messageApi.open({
                    key: message_key,
                    type: 'error',
                    content: <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto',
                        gap: '8px',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        {res.message}
                        <div style={{
                            cursor: 'pointer'
                        }} onClick={()=>{
                            messageApi.destroy(message_key)
                        }}>
                            <CloseCircleOutlined style={{color: "#D54941"}} />
                        </div>
                    </div>,
                    duration: 0, // 设置为0表示不自动关闭
                });
                if(inputEmail) {
                    if(emailFormat.test(inputEmail) && !validateOtpResult && !validateOtpLoading) {
                        setCanSendOtp(true);
                    }
                    else {
                        setCanSendOtp(false);
                    }
                }
                else {
                    setCanSendOtp(false);
                }
            }
        }).catch(error=>{
            setOtpLoading(false);
            const message_key = `custom_message_${Date.now()}`;
            messageApi.open({
                key: message_key,
                type: 'error',
                content: <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '8px',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {error.response?.data?.message || error.message}
                    <div style={{
                        cursor: 'pointer'
                    }} onClick={()=>{
                        messageApi.destroy(message_key)
                    }}>
                        <CloseCircleOutlined style={{color: "#D54941"}} />
                    </div>
                </div>,
                duration: 0, // 设置为0表示不自动关闭
            });
            if(inputEmail) {
                if(emailFormat.test(inputEmail) && !validateOtpResult && !validateOtpLoading) {
                    setCanSendOtp(true);
                }
                else {
                    setCanSendOtp(false);
                }
            }
            else {
                setCanSendOtp(false);
            }
        })
    }, [inputEmail, merchant_code, urlParams?.language, merchantCode, messageApi, 
        emailFormat, validateOtpResult, validateOtpLoading, formatMessage])

    //验证输入的验证码是否正确
    const handleValidateOtp = useCallback(otp=>{
        setValidateOtpLoading(true);
        verifyOtp({
            id: inputEmail,
            otp: otp
        }, merchantCode).then(res=>{
            setValidateOtpLoading(false);
            if(res?.status == 200) {
                setValidateOtpResult(true);
                setValidateOtpValue(res?.message);
            }
            else {
                setValidateOtpResult(false);
                setValidateOtpValue(null);
                if(!waitOtpSeconds && inputEmail) {
                    if(emailFormat.test(inputEmail)) {
                        setCanSendOtp(true);
                    }
                }
            }
        }).catch(error=>{
            setValidateOtpLoading(false);
            const message_key = `custom_message_${Date.now()}`;
            messageApi.open({
                key: message_key,
                type: 'error',
                content: <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '8px',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {error.response?.data?.message || error.message}
                    <div style={{
                        cursor: 'pointer'
                    }} onClick={()=>{
                        messageApi.destroy(message_key)
                    }}>
                        <CloseCircleOutlined style={{color: "#D54941"}} />
                    </div>
                </div>,
                duration: 0, // 设置为0表示不自动关闭
            });
        })
    }, [emailFormat, inputEmail, messageApi, waitOtpSeconds, merchantCode])

    //保存验证码框输入的值，有值输入则让按钮置灰
    const handleChangeOTP = useCallback((val)=>{
        const otp_val = val.currentTarget.value;
        setValidateOtpResult(null);
        setValidateOtpValue(null);
        setOtpValue(otp_val);
        if(emailFormat.test(inputEmail)) {
            if(otp_val?.length === 6) {
                setCanSendOtp(false);
                handleValidateOtp(otp_val);
            }
            else if(!waitOtpSeconds) {
                setCanSendOtp(true);
            }
        }
        
    }, [handleValidateOtp, waitOtpSeconds, inputEmail, emailFormat]);

    //清空表单数据
    const handleClearAllData = useCallback((values)=>{
        let form_object = {};
        Object.keys(values).forEach(key=>{
            form_object[key] = undefined
        })
        form.setFieldsValue(form_object);
        setSearchValue({});
        setDateString(undefined);
        setBase64List([]);
        setFileList([]);
        // setAlertMessage([]);
        setUploadAlertMessage([]);
    }, [form]);

    //提交表单
    const handleSubmitForm = useCallback((values)=>{
        let fileRequire = false;
        warrantyGroup.forEach(item=>{
            item.forEach(item2=>{
                item2.groupField.forEach(item3=>{
                    if(item3.fieldCode === 'upload') {
                        fileRequire = item3.isRequired
                    }
                })
            })
        })
        if(fileRequire && base64List?.length === 0) {
            const message_key = `custom_message_${Date.now()}`;
            const messageContent = {
                key: message_key,
                type: 'error',
                content: <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '8px',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {formatMessage({
                        id: "form.uploadNumTips", 
                        defaultMessage: "Must be upload a file."
                    })}
                    {/* <div style={{
                        cursor: 'pointer'
                    }} onClick={()=>{
                        messageApi.destroy(message_key)
                    }}>
                        <CloseCircleOutlined style={{color: "#D54941"}} />
                    </div> */}
                </div>,
                duration: 0, // 设置为0表示不自动关闭
            }
            // messageApi.open(messageContent);
            setAlertMessage([messageContent])
            return;
        }
        if(!validateOtpValue) {
            const message_key = `custom_message_${Date.now()}`;
            const messageContent = {
                key: message_key,
                type: 'error',
                content: <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '8px',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {formatMessage({
                        id: "form.OTPTips", 
                        defaultMessage: "Please enter a valid OTP."
                    })}
                    {/* <div style={{
                        cursor: 'pointer'
                    }} onClick={()=>{
                        messageApi.destroy(message_key)
                    }}>
                        <CloseCircleOutlined style={{color: "#D54941"}} />
                    </div> */}
                </div>,
                duration: 0, // 设置为0表示不自动关闭
            }
            // messageApi.open(messageContent);
            setAlertMessage([messageContent])
            return;
        }
        const sentValues = {
            warranty_code: urlParams?.code || 'default',
            language: urlParams?.language || 'global',
            [formToken.key]: formToken.value,
            ...values,
            invoice_date: dateString,
            subscribe: values.subscribe ? true : false,
            upload: base64List?.length > 0 ? base64List[0].data : '',
            otp: validateOtpValue
        }
        setAlertMessage([]);
        setLoading(true);
        sendWarrantyForm(sentValues, merchantCode).then(res=>{
            if(res?.status === '200') {
                const message_key = `custom_message_${Date.now()}`;
                const messageContent = {
                    key: message_key,
                    type: 'info',
                    content: formatMessage({
                        id: "form.sendSuccessMsg", 
                        defaultMessage: "Send Success!"
                    }),
                    duration: 5, // 设置为0表示不自动关闭
                }
                // messageApi.open(messageContent);
                setAlertMessage([messageContent])
                handleClearAllData(values);
                if(!btnDisable) {
                    setBtnDisable(true);
                    setTimeout(()=>{
                        handleGetFormData(urlParams?.code, urlParams?.language, false, merchantCode);
                    }, 5000);
                }
            }
            else {
                const message_key = `custom_message_${Date.now()}`;
                const messageContent = {
                    key: message_key,
                    type: 'error',
                    content: <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto',
                        gap: '8px',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        {res.message}
                        {/* <div style={{
                            cursor: 'pointer'
                        }} onClick={()=>{
                            messageApi.destroy(message_key)
                        }}>
                            <CloseCircleOutlined style={{color: "#D54941"}} />
                        </div> */}
                    </div>,
                    duration: 0, // 设置为0表示不自动关闭
                }
                // messageApi.open(messageContent);
                setAlertMessage([messageContent])
                if(!btnDisable) {
                    setBtnDisable(true);
                    handleGetFormData(urlParams?.code, urlParams?.language, false, merchantCode);
                }
            }
            setValidateOtpResult(null);
            setValidateOtpValue(null);
            setOtpValue('');
            form.setFieldValue('otp', '');
            if(!waitOtpSeconds && inputEmail) {
                if(emailFormat.test(inputEmail)) {
                    setCanSendOtp(true);
                }
            }
            setLoading(false);
        }).catch(error=>{
            setLoading(false);
            setValidateOtpResult(null);
            setValidateOtpValue(null);
            if(!waitOtpSeconds && inputEmail) {
                if(emailFormat.test(inputEmail)) {
                    setCanSendOtp(true);
                }
            }
            setOtpValue('');
            form.setFieldValue('otp', '');
            if(!btnDisable) {
                setBtnDisable(true);
                handleGetFormData(urlParams?.code, urlParams?.language, false, merchantCode);
            }
            const message_key = `custom_message_${Date.now()}`;
            const messageContent = {
                key: message_key,
                type: 'error',
                content: <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '8px',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {error.response?.data?.message || error.message}
                    {/* <div style={{
                        cursor: 'pointer'
                    }} onClick={()=>{
                        messageApi.destroy(message_key)
                    }}>
                        <CloseCircleOutlined style={{color: "#D54941"}} />
                    </div> */}
                </div>,
                duration: 0, // 设置为0表示不自动关闭
            }
            // messageApi.open(messageContent);
            setAlertMessage(messageContent)
        })
    }, [warrantyGroup, base64List, validateOtpValue, urlParams, formToken, dateString, merchantCode, messageApi, 
        formatMessage, form, waitOtpSeconds, inputEmail, btnDisable, handleGetFormData, emailFormat, handleClearAllData])

    useEffect(()=>{
        if(pathname.includes('/warranty') && search && merchant_code) {
          const params = new URLSearchParams(search);
          const languageId = params.get('language');
          const formCode = params.get('code');
          const code = merchant_code === 'uat_test' ? '' : `api/merchant/${merchant_code}/warranty/`;
          setMerchantCode(code);
          setUrlParams({
            code: formCode || 'default',
            language: languageId || 'global'
          })
          setLoading(true);
          handleGetFormData(formCode || 'default', languageId || 'global', true, code);
        }
        else {
            setErrorMessage("empty form")
        }
      }, [search, pathname])

    return {
        loading,
        errorMessage,
        form,
        warrantyGroup,
        allSelectOptions,
        allSelectValues,
        handleChangeSelect,
        contextHolder,
        fileList,
        handleRemoveFile,
        handleBeforeUpload,
        handleFormatFile,
        handleOnChangeFile,
        handleChangeDatePicker,
        handleSubmitForm,
        handleGetRules,
        otpLoading,
        canSendOtp,
        waitOtpSeconds,
        handleStartSendOtp,
        handleChangeEmail,
        handleChangeOTP,
        otpValue,
        validateOtpLoading,
        validateOtpResult,
        btnDisable,
        searchValue,
        setSearchValue,
        alertMessage,
        setAlertMessage,
        uploadAlertMessage,
        setUploadAlertMessage
    }
}